// extracted by mini-css-extract-plugin
export default {"text":"TableText_text__u2ZtA","bold":"TableText_bold__Eb25R","light":"TableText_light__dadF1"};